import { Button, Space } from "antd";
import React from "react";

import * as styles from "./NavigationFooterStyles.module.scss";

type Props = {
  onCancel: () => void;
  onContinue?: () => void;
  disabled?: boolean;
  hideBackBtn?: boolean;
  nextLabel?: string;
};

const NavigationFooter = ({
  onCancel,
  onContinue,
  disabled = false,
  hideBackBtn = false,
  nextLabel = "Continue",
}: Props) => (
  <Space className={styles.navigationFooter}>
    {!hideBackBtn ? (
      <Button data-cy="back-btn" onClick={onCancel}>
        Back
      </Button>
    ) : (
      <div />
    )}
    {onContinue && (
      <Button
        data-cy="next-btn"
        className={styles.nextButton}
        onClick={onContinue}
        disabled={disabled}
      >
        {nextLabel}
      </Button>
    )}
  </Space>
);

export default NavigationFooter;
